import React, { ReactNode } from "react";
import styles from "./sub-title.module.scss";

interface SubTitlePropTypes {
  text: string | ReactNode;
}

export const SubTitle = ({ text }: SubTitlePropTypes) => {
  return <h2 className={styles.subtitle}>{text}</h2>;
};
